import { FormikProps } from 'formik';

type SubmitFormParams = {
  submitForm: FormikProps<unknown>['submitForm'];
  validateForm: FormikProps<unknown>['validateForm'];
};

/**
 * A temporary hack-fixed version of Formik's `submitForm` that actually rejects the promise if
 * there are validation errors in the form. Currently, Formik's out-of-the-box `submitForm` is bugged
 * and will successfully resolve the promise even if there are validation errors.
 *
 * @see https://github.com/formium/formik/issues/1580
 */
export function fixedSubmitForm({ submitForm, validateForm }: SubmitFormParams): Promise<void> {
  return new Promise((resolve, reject) => {
    submitForm()
      .then(validateForm)
      .then(errors => {
        if (Object.keys(errors).length > 0) {
          reject();
        } else {
          resolve();
        }
      })
      .catch((err: Error) => {
        console.warn(`Form submission error: ${err.message}`);
        reject();
      });
  });
}
